import { render, staticRenderFns } from "./AthleteSelfAssessmentsCard.vue?vue&type=template&id=5eb14922&scoped=true&"
import script from "./AthleteSelfAssessmentsCard.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb14922",
  null
  
)

export default component.exports